export default{
  install(Vue, options){
    Vue.prototype.taskStatusDesc = (data)=>{
      let progressName = ''
      let valueDesc = ''
      switch (data.instanceId.service.status.progress) {
        case 7:
          progressName = "创建";
          break;
        case 8:
          progressName = "建立依赖";
          break;
        case 9:
          progressName = "配置";
          break;
        case 0:
          progressName = "安装发送";
          break;
        case 1:
          progressName = "下载";
          break;
        case 2:
          progressName = "安装";
          break;
        case 3:
          progressName = "卸载";
          break;
        case 4:
          progressName = "启动";
          break;
        case 5:
          progressName = "停止";
          break;
        case 6:
          progressName = "心跳连接";
          break;
        case 10:
          progressName = "心跳中断";
          break;
        case 11:
          progressName = "启动发送";
          break;
        case 12:
          progressName = "停止发送";
          break;
        case 13:
          progressName = "心跳连接发送";
          break;
        case 14:
          progressName = "心跳中断发送";
          break;
        case 15:
          progressName = "卸载发送";
          break;
        case 16:
          progressName = "卸载备份";
          break;
        case 17:
          progressName = "释放资源";
          break;
        case 18:
          progressName = "分配资源";
          break;
        case 19:
          progressName = "下载";
          break;
        case 20:
          progressName = "同步";
          break;
        case 21:
          progressName = "热加载";
          break;
        case 22:
          progressName = "反向同步";
          break;
        case 23:
          progressName = "查看远端";
          break;
        case 24:
          progressName = "探测";
          break;
        default:
          progressName = "状态描述";
      }

      switch (data.instanceId.service.status.value) {
        case 0:
          valueDesc = '进行中';
          break;
        case 1:
          valueDesc = '成功';
          break;
        case 2:
          valueDesc = '失败';
          break;
        case 3:
          valueDesc = '等待执行';
          break;
      }

      return progressName + valueDesc
    }
  }
}
